import styled from "@emotion/styled"
import {
  InputWrapper,
  Button,
  Form,
  Icon,
  Text
} from "../../../styles/common.styled"
import { DropdownButton } from "../../../common/dropdown/dropdown.styled"
import { Input as CommonInput } from "@chakra-ui/react"

export interface StylesProps {
  error?: string
  isSmallWindowHeight?: boolean
}

export const StreamTextTip = styled(Text)<StylesProps>`
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementLabels ?? "#495057"};
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.5625rem" : "0.8125rem"};
  line-height: 17px;
  margin-bottom: ${({ error }) => (error ? "1rem" : "0.4rem")};
`

export const StreamBox = styled.div`
  margin-bottom: 0.4rem;
`

export const StreamDropdown = styled(StreamBox)`
  width: fit-content;
`

export const StreamForm = styled(Form)`
  margin-bottom: 0;
`

export const StreamSavedContainer = styled.div`
  margin-top: 0.4rem;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const StreamSavedList = styled.div`
  overflow-y: auto;
  max-height: 146px;
`

export const StreamRow = styled(InputWrapper)`
  flex-direction: row;
  margin-top: 1px;
  &:last-of-type {
    margin-bottom: 1px;
  }
`

export const StreamNetwork = styled(DropdownButton)`
  cursor: default;
  padding: 0.375rem;
  &:after {
    display: none;
  }
`

export const StreamLabel = styled(CommonInput)`
  width: 100%;
  color: #495057;
  background-color: #e9ecef;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StreamIcon = styled(Icon)`
  margin-right: 5px;
  flex-shrink: 0;
`

export const StartStreamingButton = styled(Button)`
  width: fit-content;
  flex-shrink: 0;
  margin-left: 10px;
  margin-right: 6px;
  margin-bottom: 0;
  &:disabled {
    opacity: 0.25;
  }
`

export const StreamFacebookIcon = styled(StreamIcon)`
  color: #3a5794;
`

export const StreamTwitterIcon = styled(StreamIcon)`
  color: #1da1f2;
`

export const StreamInstagramIcon = styled(StreamIcon)`
  color: white;
`
export const StreamTwitchIcon = styled(StreamIcon)`
  color: #9147ff;
`
export const StreamVimeoIcon = styled(StreamIcon)`
  color: #02acef;
`
export const StreamYoutubeIcon = styled(StreamIcon)`
  color: #ff0100;
`
export const StreamBroadcastIcon = styled(StreamIcon)`
  color: #ff0100;
`
